/**
 * 시스템 > 모니터링 설정 > Ticket 그룹 설정 Store
 *
 * @since 2021-05-24
 * @author wj_tams_dev01
 */
import {SystemApiPrefix as smApi} from '~/utils/restApi'

export const state = () => ({
  ticketApi: `${smApi}/ticket-config`,
  ticketList: [], // 티켓 설정 리스트
  api: {
    url: `${smApi}/ticket-group`,
    config: {
      loading: false,
      successAlert: false
    }
  },
  ticket: {
    total: 'ticket_config_total_list',
    group: 'ticket_group_list',
    user: 'ticket_user_list',
    reg: 'ticket_config_register_list'
  },
  unregList: [], // 등록 가능한 티켓 리스트
  groupList: [], // 티켓 그룹 리스트
  regList: [], // 티켓 등록 리스트
  userList: [] // 티켓 사용자 설정 리스트
})

export const mutations = {
  // 티켓 리스트 획득
  setTicketList (state, data) {
    state.ticketList = _.cloneDeep(data)
  },
  // 등록 가능한 티켓 리스트 설정 - ticket 설정.
  setUnregTicket (state, data) {
    state.unregList = _.cloneDeep(data)
  },
  setGroup (state, data) {
    state.groupList = _.cloneDeep(data[state.ticket.group]) || []
  },
  setUser (state, data) {
    state.userList = _.cloneDeep(data)
  },
  setTicket (state, data) {
    state.ticketList = _.cloneDeep(data[state.ticket.total]) || []
    state.regList = _.cloneDeep(data[state.ticket.reg]) || []
    // state.unregList = _.cloneDeep(data.unregister_ticket_config_list) || []
  },
  // Ticket Group 설정 - ticket Group 초기 정보 설정.
  setGroupInfo (state, data) {
    state.ticketList = _.cloneDeep(data[state.ticket.total]) || []
    state.groupList = _.cloneDeep(data[state.ticket.group]) || []
    state.userList = _.cloneDeep(data[state.ticket.user]) || []
    state.regList = _.cloneDeep(data[state.ticket.reg]) || []
    // state.unregList = _.cloneDeep(data.ticket_config_unregister_list) || []
  },
  clearList (state) {
    state.userList = []
    state.regList = []
  }
}

export const actions = {
  // 현재 범위 참조 : dispatch
  // mutation 범위 참조 : commit
  // 티켓 리스트 획득
  async getTicketList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.ticketApi}`)
    if (code && code.toLowerCase() === 'ok') {
      commit('setTicketList', result)
      return ''
    }
    return result.msg || ''
  },
  // Ticket Group 정보 획득 - Ticket Group 정보(user, ticket) 가져오기
  async getGroupInfo ({commit, state}, ticketGroupId) {
    const
      api = `${state.api.url}${_.isNil(ticketGroupId) ? '' : `/${ticketGroupId}`}`,
      {code, result} = await this.$axios.$get(api, state.api.config)

    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setGroupInfo', result)
    }
    return {code, result}
  },
  // Ticket Group 정보 획득 - 미등록 Ticket 정보.
  async getUnregTicket ({commit, state}, ticketGroupId) {
    const {code, result} = await this.$axios.$get(`${state.api.url}/${ticketGroupId}/config`, state.api.config)

    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setUnregTicket', result)
    }
    return {code, result}
  },
  // Ticket Group 정보 획득 - User 가져오기
  async getUserInfo ({commit, state}, ticketGroupId) {
    const
      api = `${state.api.url}${_.isNil(ticketGroupId) ? '' : `/${ticketGroupId}`}/user`,
      {code, result} = await this.$axios.$get(api, state.api.config)

    return {code, result}
  },
  // Ticket Group 등록 - Ticket Group 설정.
  async addGroupInfo ({commit, state}, items) {
    const {code, result} = await this.$axios.$post(state.api.url, items, state.api.config)

    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setGroup', result)
    }
    return {code, result}
  },
  async markedUserInfo ({commit, state}, [items, groupId]) {
    const {code, result} = await this.$axios.$put(`${state.api.url}/${groupId}/user`, items, state.api.config)
    return {code, result}
  },
  // Ticket Group 등록 - User 일괄 등록.
  async editUser ({commit, state}, [items, groupId]) {
    const {code, result} = await this.$axios.$post(`${state.api.url}/${groupId}/user`, {'ticket_user_list': items}, state.api.config)

    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setUser', result)
    }
    return {code, result}
  },
  // Ticket Group 등록 - Ticket 일괄 등록.
  async editTicket ({commit, state}, [items, groupId]) {
    const {code, result} = await this.$axios.$post(`${state.api.url}/${groupId}/config`, {'ticket_config_list': items}, state.api.config)

    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setTicket', result)
    }
    return {code, result}
  },
  async delList ({commit, state}, [item, groupId = null]) {
    const
      isDelGroup = _.isNil(groupId),
      url = isDelGroup ? state.api.url : `${state.api.url}/${groupId}/config`,
      param = [url, { data: item }]

    const {code, result} = await this.$axios.$delete(
      ...param,
      state.api.config
    )

    if (code !== undefined && (code).toLowerCase() === 'ok') {
      if (isDelGroup) {
        commit('setGroup', result)
      } else {
        commit('setTicket', result)
      }
    }
    return {code, result}
  },
  async finalCommand ({commit, state}, {type, loadingShow = true}) {
    if (!_.includes(['apply', 'cancel'], type)) return 'nok'
    try {
      const param = _.assign({ loadingShow: loadingShow }, (_.eq(type, 'apply')) ? { applyMsg: true } : { cancelMsg: true })
      const {code, result} = await this.$axios.$put(`${state.api.url}/${type}`, null, param)
      if (code !== 'ok') {
        return result.msg
      }
      return code
    } catch (e) {
      this.$log('[Ticket] finalCommand Exception -> ', e)
      return e
    }
  }
}

export const getters = {
}

export const strict = false
